.#{$namespace}-number {
	position: relative;
	box-sizing: border-box;
	width: 100%;
	display: inline-flex;
	align-items: center;
	border: 1px solid $border-color;
	border-radius: 8px;
	background-color: $white-color;
	overflow: hidden;
	height: $control-height;

	input {
		flex: 1;
		min-width: 0; // input 默认 min-width:auto，不设的话 flex:1 会被内容撑死
		width: 0;
		height: 100%;
		border: none;
		outline: none;
		background: transparent;
		padding-block: 0;
		padding-inline: calc($control-height * 0.45);
		font-size: $font-size;
		&[type='number'] {
			-moz-appearance: textfield;
			appearance: textfield;
			&::-webkit-outer-spin-button,
			&::-webkit-inner-spin-button {
				-webkit-appearance: none;
				margin: 0;
			}
		}
	}
	.decrease,
	.increase {
		display: flex;
		align-items: center;
		justify-content: center;
		user-select: none;
		height: 100%;
		width: 30px;
		background-color: color-token(info, light-9);
		cursor: pointer;
		.icon {
			font-size: $font-size;
		}
	}
	.prefix,
	.suffix {
		display: flex;
		align-items: center;
		justify-content: center;
		width: $control-height;
		height: 100%;
		cursor: auto;
		.icon {
			font-size: $font-size;
		}
	}
	.suffix {
		.icon {
			&.close {
				pointer-events: none;
				opacity: 0;
				color: $text-placeholder-color;
				&:hover {
					color: color-token(danger);
				}
			}
		}
	}
	&.is-controls {
		input {
			text-align: center;
		}
	}
	&.is-disabled {
		.decrease,
		.increase {
			cursor: auto;
		}
	}
	&.is-focus,
	&:hover {
		&:not(.is-disabled) {
			.suffix {
				.icon {
					&.close {
						cursor: pointer;
						pointer-events: auto;
						opacity: 1;
					}
				}
			}
		}
	}
	&.is-focus {
		border-color: color-token(primary);
	}
}
